export default __webpack_public_path__ + "static/media/unionpay.15a19fbd.svg";